import Vue from 'vue'

const maintenance = {
    blockLogin: false,
    showAlert: false,
    alertType: 'info', //info, warning, error
    alertMessage: '只今メンテナンス中です。\n'
    + 'ご迷惑をおかけしますが、何卒宜しくお願い致します。\n\n'
    + '予定期間： 10月22日(火)  18:10 ～ 20:20 \n'
}

export default ({ app }, inject) => {
    inject('maintenance', maintenance);
}